export const PAYOUTS = [
4200000,
2268000,
1428000,
1008000,
840000,
756000,
703500,
651000,
609000,
567000,
525000,
483000,
441000,
399000,
378000,
357000,
336000,
315000,
294000,
273000,
252000,
235200,
218400,
201600,
184800,
168000,
161700,
155400,
149100,
142800,
136500,
130200,
123900,
118650,
113400,
108150,
102900,
98700,
94500,
90300,
86100,
81900,
77700,
73500,
69300,
65100,
60900,
57540,
54600,
52920,
25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000,
25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000, 25000,
];
